<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9xbYnG/tc-custom/9780547416144.jpg?1726273261652" alt="This image is the cover for the book Cold in Hand, The Charlie Resnick Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cold in Hand, The Charlie Resnick Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>“A welcome return for Nottingham Inspector Charlie Resnick</b><b>, </b><b>who’s been absent from novel-length crime-fighting since </b><b><i>Last Rites</i></b><b>.”—<i>Kirkus Reviews</i></b><br/>  <br/> It’s Valentine’s Day, and a dispute between rival gangs leaves a teenage girl dead. Detective Inspector Charlie Resnick, nearing retirement, is hauled back to the front line to help deal with the fallout. But when the dead girl’s father seeks to lay the blame on Resnick’s partner, DI Lynn Kellogg, Resnick finds the line between the personal and the professional dangerously blurred. <br/>  <br/> Meanwhile, the Serious and Organized Crime Agency starts to show a keen interest in one of Kellogg’s murder cases—a case the agency is convinced is linked to international gun running and people trafficking. Soon Kellogg is drawn into a web of deceit and betrayal that puts both her and Resnick in mortal danger. In <i>Cold in Hand</i>, John Harvey brings back “one of the most fully realized characters in modern crime fiction” in another heart-stopping procedural (Sue Grafton).<br/>  <br/> “The book is quite possibly Harvey’s most authoritative in years: visceral, engaged and, yes, unputdownable.”—<i>Independent</i><br/>  <br/> “It’s impossible not to greet the return of Resnick in this eleventh, coda-like, deeply melancholy novel with anything but celebration.”—<i>Booklist</i> (starred review)<br/>  <br/> “Impassioned, at times heartbreaking . . . [<i>Cold in Hand</i>] confirms Harvey as one of our most accomplished writers in any genre.”—<i>Sunday Telegraph</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Harvey
      </h2>
      
      <p class="authorDescription body article">John Harvey (b. 1938) is an incredibly prolific British mystery writer. The author of more than one hundred books, as well as poetry and scripts for television and radio, Harvey did not begin writing professionally until 1975. Until then he was a teacher, educated at Goldsmiths College, London, who taught literature, drama, and film at colleges across England. After cutting his teeth on paperback fiction, Harvey debuted his most famous character, Charlie Resnick, in 1989&rsquo;s <i>Lonely Hearts</i>, which the English <i>Times</i> called one of the finest crime novels of the century.&#160;A police inspector noted for his love of both sandwiches and jazz, Resnick has starred in eleven novels and one volume of short stories. The BBC has adapted two of the Resnick novels, <i>Lonely Hearts</i> and <i>Rough Treatment</i> (1990), for television movies. Both starred Academy Award&ndash;nominated actor Tom Wilkinson and had screenplays written by Harvey. Besides writing fiction, Harvey spent over twenty years as the head of Slow Dancer Press. He continues to live and write in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55576d56